class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  }

  renderContents(parsedState) {
    console.log('renderContents called with:', parsedState); // Debug
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    
    // Handle cart-drawer section
    const cartDrawerHtml = parsedState.sections['cart-drawer'];
    console.log('cart-drawer HTML length:', cartDrawerHtml ? cartDrawerHtml.length : 0); // Debug
    if (cartDrawerHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartDrawerHtml, 'text/html');
      
      // Shopify returns HTML wrapped in a section div
      const sectionDiv = doc.querySelector('#shopify-section-cart-drawer') || doc.querySelector('.shopify-section');
      console.log('sectionDiv found:', !!sectionDiv); // Debug
      const newCartDrawer = sectionDiv ? sectionDiv.querySelector('cart-drawer') : doc.querySelector('cart-drawer');
      console.log('newCartDrawer found:', !!newCartDrawer); // Debug
      
      if (newCartDrawer) {
        const newDrawerInner = newCartDrawer.querySelector('.drawer__inner');
        const currentDrawerInner = this.querySelector('.drawer__inner');
        console.log('newDrawerInner found:', !!newDrawerInner, 'currentDrawerInner found:', !!currentDrawerInner); // Debug
        
        if (newDrawerInner && currentDrawerInner) {
          // Replace the entire drawer__inner content
          const newContent = newDrawerInner.innerHTML;
          console.log('Replacing drawer__inner content, new content length:', newContent.length); // Debug
          currentDrawerInner.innerHTML = newContent;
          
          // Force re-initialization of custom elements by removing and re-adding
          // This ensures custom elements are properly initialized
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = newContent;
          
          // Replace cart-drawer-items
          const oldCartDrawerItems = currentDrawerInner.querySelector('cart-drawer-items');
          const newCartDrawerItems = tempContainer.querySelector('cart-drawer-items');
          console.log('cart-drawer-items - old:', !!oldCartDrawerItems, 'new:', !!newCartDrawerItems); // Debug
          if (oldCartDrawerItems && newCartDrawerItems) {
            oldCartDrawerItems.replaceWith(newCartDrawerItems);
          }
          
          // Replace quantity-input elements
          const oldQuantityInputs = currentDrawerInner.querySelectorAll('quantity-input');
          const newQuantityInputs = tempContainer.querySelectorAll('quantity-input');
          console.log('quantity-inputs - old:', oldQuantityInputs.length, 'new:', newQuantityInputs.length); // Debug
          oldQuantityInputs.forEach((oldEl, index) => {
            if (newQuantityInputs[index]) {
              oldEl.replaceWith(newQuantityInputs[index]);
            }
          });
          
          // Replace quantity-popover elements
          const oldQuantityPopovers = currentDrawerInner.querySelectorAll('quantity-popover');
          const newQuantityPopovers = tempContainer.querySelectorAll('quantity-popover');
          console.log('quantity-popovers - old:', oldQuantityPopovers.length, 'new:', newQuantityPopovers.length); // Debug
          oldQuantityPopovers.forEach((oldEl, index) => {
            if (newQuantityPopovers[index]) {
              oldEl.replaceWith(newQuantityPopovers[index]);
            }
          });
          
          console.log('Cart drawer content updated successfully'); // Debug
        } else {
          console.warn('Could not find drawer__inner elements'); // Debug
        }
      } else {
        console.warn('Could not find cart-drawer in parsed HTML'); // Debug
      }
    } else {
      console.warn('No cart-drawer HTML in parsedState.sections'); // Debug
    }

    // Update cart icon bubble if present
    const cartIconBubbleHtml = parsedState.sections['cart-icon-bubble'];
    if (cartIconBubbleHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartIconBubbleHtml, 'text/html');
      const sectionDiv = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
      if (sectionDiv) {
        const currentCartIconBubble = document.querySelector('#cart-icon-bubble');
        if (currentCartIconBubble) {
          currentCartIconBubble.innerHTML = sectionDiv.innerHTML;
        }
      }
    }

    // Update cart count
    if (parsedState.item_count !== undefined) {
      const cartCount = document.querySelector('.header__cart-count');
      if (cartCount) {
        cartCount.textContent = parsedState.item_count;
      }
    }

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (selector === '#CartDrawer') {
      const cartDrawer = doc.querySelector('cart-drawer');
      if (cartDrawer) {
        const cartDrawerDiv = cartDrawer.querySelector('#CartDrawer');
        return cartDrawerDiv ? cartDrawerDiv.innerHTML : '';
      }
    }
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
